import React from "react";

import PixelFire from "./PixelFire";
import StreakSaveExplanationModal from "./StreakSaveExplanationModal";

export default function StreakSaveBalanceBtn({ balance }) {
  const [modalVisible, setModalVisible] = React.useState(false);

  if (balance == null) return null;

  return (
    <>
      <button
        aria-label={`${balance} Streak Save${balance === 1 ? "" : "s"} available`}
        className="btn btn-default btn-xs tw-mr-2"
        onClick={() => setModalVisible(true)}
      >
        <span style={{ marginRight: 4, display: "inline-flex", verticalAlign: "middle" }}><PixelFire size={14} /></span>
        {balance}
      </button>
      <button className="btn btn-link btn-xs tw-mr-2" onClick={() => setModalVisible(true)}>
        Learn more
      </button>
      {modalVisible && (
        <StreakSaveExplanationModal balance={balance} onHidden={() => setModalVisible(false)} />
      )}
    </>
  );
}
